import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as JSZip from 'jszip';
import * as moment from 'moment';
import { map } from 'rxjs/operators';

import { ApiLavandierService } from '../../../../../lib/lib-ngx/web-services/api-lavandier.service';
import { ErrorService } from '../../../../../lib/lib-ngx/services/error.service';
import { IOrderGetUserIdReq } from '../../../../../lib/lib-shared/api/lavandier/Order.Type';
import { ErrorMessage } from '../../../../../lib/lib-shared/ErrorMessage';

@Component({
  selector: 'lm-user-profile-invoices',
  templateUrl: './user-profile-invoices.component.html',
})
export class UserProfileInvoicesComponent implements OnInit {
  @Input() userId: number;

  public houseNameList: string[] = [];
  public invoiceForm: FormGroup;
  public downloading = false;
  public downloadedCount = 0;
  public invoiceCount = 0;

  constructor(
    private fb: FormBuilder,
    private apiLavandierService: ApiLavandierService,
    private errorService: ErrorService,
  ) {
  }

  ngOnInit() {
    this.initForm();
    this.loadHouseNameList();
  }

  private initForm() {
    this.invoiceForm = this.fb.group({
      houseName: [''],
      month: [moment().format('YYYY-MM'), Validators.required],
    });
  }

  private loadHouseNameList() {
    this.apiLavandierService.getOrderUserHousename(this.userId, {})
      .pipe(map(orderList => orderList.map(o => o.houseName).filter(Boolean) as string[]))
      .subscribe(houseNameList => this.houseNameList = houseNameList);
  }

  downloadInvoicesMonth() {
    const houseName = this.invoiceForm.controls.houseName.value;
    const selectedMonth = this.invoiceForm.controls.month.value as string;
    this.downloadInvoices({
      finish: true,
      ...houseName && {houseName: houseName},
      invoiceAtMonth: selectedMonth,
    }, `factures${houseName ? `-${houseName}` : ''}-${selectedMonth}.zip`);
  }

  downloadAllInvoices() {
    const houseName = this.invoiceForm.controls.houseName.value;
    this.downloadInvoices({
      finish: true,
      ...houseName && {houseName: houseName},
    }, `factures${houseName ? `-${houseName}` : ''}.zip`);
  }

  private async downloadInvoices(params: IOrderGetUserIdReq, filename: string) {
    this.downloading = true;
    this.invoiceCount = 0;
    try {
      const orderList = await this.apiLavandierService.getOrderUserIdList(this.userId, params).toPromise();
      if (this.errorService.manageError(orderList)) {
        return;
      }
      if (!orderList.rows.length) {
        this.errorService.showModal(ErrorMessage.INVOICE_NOT_AVAILABLE);
        return;
      }

      const zip = new JSZip();
      this.downloadedCount = 0;
      this.invoiceCount = orderList.rows.length;
      for (const order of orderList.rows) {
        const pdf = await this.apiLavandierService.getDocInvoice(order.id).toPromise();
        zip.file(`invoice${!params.houseName && order.houseName ? `-${order.houseName}` : ''}-${order.id}.pdf`, pdf);
        this.downloadedCount++;
      }

      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(await zip.generateAsync({type: 'blob'}));
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(a.href);
    } finally {
      this.downloading = false;
    }
  }
}
